module.exports = __webpack_public_path__ + "static/media/bg_top.1079aec3.png";